import { defineMessages } from '@/components/formatted_message/FormattedMessage';
import { Locale } from '@enmon/commons';

export const LOCALE_TRANSLATED = defineMessages<Locale>({
  [Locale.EN]: { id: 'app.common.locale.en' },
  [Locale.CS]: { id: 'app.common.locale.cs' },
  [Locale.SK]: { id: 'app.common.locale.sk' },
  [Locale.PL]: { id: 'app.common.locale.pl' },
});
